import type { TabNavItem } from '@mercedes-benz/odp-theme-v2';
import { ComponentsIcon, RelationsIcon } from '@mercedes-benz/odp-theme-v2';
import {
  RELATION_API_CONSUMED_BY,
  RELATION_API_PROVIDED_BY,
} from '@backstage/catalog-model';
import InfoIcon from '@mui/icons-material/Info';
import CodeIcon from '@mui/icons-material/Code';
import FeedbackIcon from '@mui/icons-material/Feedback';
import { EntityPageLayout } from './EntityPageLayout';
import { CoreDetailsTab } from '../system-details/CoreDetailsTab';
import { RelationsTab } from '../system-details/RelationsTab';
import { RelatedEntitiesTab } from './RelatedEntitiesTab';
import { ApiDefinitionTab } from './ApiDefinitionTab';
import { FeedbackTab } from './FeedbackTab';

const TABS: TabNavItem[] = [
  { id: 'overview', label: 'Overview', icon: InfoIcon },
  { id: 'definition', label: 'Definition', icon: CodeIcon },
  { id: 'providers', label: 'Provided By', icon: ComponentsIcon },
  { id: 'consumers', label: 'Consumed By', icon: ComponentsIcon },
  { id: 'feedback', label: 'Feedback', icon: FeedbackIcon },
  { id: 'relations', label: 'Relations', icon: RelationsIcon },
];

export const ApiEntityPage = () => (
  <EntityPageLayout tabs={TABS}>
    {activeTab => (
      <>
        {activeTab === 'overview' && <CoreDetailsTab />}
        {activeTab === 'definition' && <ApiDefinitionTab />}
        {activeTab === 'providers' && (
          <RelatedEntitiesTab
            relationType={RELATION_API_PROVIDED_BY}
            title="Provided By"
          />
        )}
        {activeTab === 'consumers' && (
          <RelatedEntitiesTab
            relationType={RELATION_API_CONSUMED_BY}
            title="Consumed By"
          />
        )}
        {activeTab === 'feedback' && <FeedbackTab />}
        {activeTab === 'relations' && <RelationsTab />}
      </>
    )}
  </EntityPageLayout>
);
